import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VerifiedIcon from '@mui/icons-material/Verified';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import UploadDocForm from './UploadDocForm';
import VerifyContent from './VerifyContent';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { Button, Card, Grid, ListItemIcon } from '@mui/material';
import VerifyRequests from './VerifyRequests';
import { Indicators } from './Indicators';
import NewsEditorForm from './NewsEditor';
import Activities from './Activities';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useDispatch } from 'react-redux';
import { LOGOUT } from '../../Constants/ActionTypes';
import { useNavigate } from 'react-router-dom';
import IndicatorData from './IndicatorData.json';
import { useState } from 'react';
import { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Published from './Published';
import Logo from '../../utils/logo/Logo.png';
import SDGWheel from '../../utils/Img/sdg-wheel.png';

const drawerWidth = 240;

function AdminDashboard(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [clickedItem, setClickedItem] = React.useState(1);
  const [heading, setHeading] = React.useState('Indicators');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [indData, setIndData] = useState([]);
  const [scroll, setScroll] = useState('paper');
  const [content, setContent] = useState(IndicatorData);
  const handleOpen = indicator => {
    setOpen(true);
    console.log('indicator', indicator);
    setContent(indicator);
    setIndData(indicator.indicators);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleLogout = e => {
    e.preventDefault();
    dispatch({ type: LOGOUT });
    navigate('/login');
  };

  const drawer = (
    <div>
      <Toolbar sx={{ display: 'flex', justifyContent: 'center' }}>
        {' '}
        <Typography
          variant="h5"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            fontFamily: 'Sora',
            color: '#FF7345',
          }}
        >
          <img style={{ width: '45px' }} src={Logo} alt="" />
        </Typography>
      </Toolbar>

      <Divider />

      <List>
        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(0);
            setHeading('Activities');
          }}
        >
          <ListItemIcon>
            <WorkspacesIcon />
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}>Activities</Typography>
          </ListItemText>
        </ListItem>

        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(1);
            setHeading('Indicators');
          }}
        >
          <ListItemIcon>
            <BorderColorIcon />
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}>Indicators</Typography>
          </ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(2);
            setHeading('Upload Project');
          }}
        >
          <ListItemIcon>
            <UploadFileIcon />
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}> Upload Content</Typography>
          </ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(3);
            setHeading('Verify Content');
          }}
        >
          <ListItemIcon>
            <VerifiedIcon></VerifiedIcon>
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}> Verify Content</Typography>
          </ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(4);
            setHeading('Verify Requests');
          }}
        >
          <ListItemIcon>
            <VerifiedUserIcon></VerifiedUserIcon>
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}> Verify Requests</Typography>
          </ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(5);
            setHeading('Upload News');
          }}
        >
          <ListItemIcon>
            <NewspaperIcon></NewspaperIcon>
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}> News Editor</Typography>
          </ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={e => {
            e.preventDefault();
            setClickedItem(6);
            setHeading('Published Papers');
          }}
        >
          <ListItemIcon>
            <VerifiedIcon></VerifiedIcon>
          </ListItemIcon>
          <ListItemText sx={{ fontFamily: 'Sora' }}>
            <Typography sx={{ fontFamily: 'Sora' }}> Published Papers</Typography>
          </ListItemText>
        </ListItem>
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', height: ['1000px', '700px', '500px'] }}>
      {/* <CssBaseline /> */}
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: 'white',
          boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
        }}
      >
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ fontFamily: 'Sora', color: '#223230' }}>
            {heading}
          </Typography>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              fontFamily: 'Sora',
              color: '#223230',
              position: 'absolute',
              right: 50,
              cursor: 'pointer',
              color: 'red',

              '&:hover': {
                color: 'green',
              },
            }}
            onClick={handleLogout}
          >
            Logout
          </Typography>
        </Toolbar>
      </AppBar>
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {clickedItem === 0 ? (
        <div style={{ display: 'flex' }}>
          <Box
            sx={{
              // backgroundColor: '#ffffff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '90vw',
              height: '90vh',
              marginTop: 10,
              // marginLeft: 10,
              // px: 2,
              // py: 2,
            }}
          >
            {/* <Activities /> */}
            <img style={{ width: '50%', height: 'auto' }} src={SDGWheel} alt="" />
          </Box>

          {/* <Box sx={{ display: 'flex', flexGrow: 1, my: 2, paddingLeft: [0, 0, 0, 0, 0] }}>
            <Grid
              container
              spacing={{ md: -3, md: 0, lg: 0 }}
              columns={{ xs: 4, sm: 8, md: 8, lg: 8 }}
              sx={{ height: '42vh', overflowY: 'scroll', ml: 3, backgroundColor: '#ffffff' }}
            >
              {IndicatorData.map((indicator, idx) => (
                <Grid
                  item
                  xs={0}
                  sm={0}
                  md={4}
                  lg={4}
                  key={idx + 1}
                  sx={{ display: 'flex', justifyContent: ['right', 'left', 'right', 'center'] }}
                >
                  <Card
                    sx={{
                      // color: '#fff',
                      border: 0,
                      height: 'fitContent',
                      width: '300px',
                      display: 'flex',
                      flexDirection: 'column',
                      p: 2,
                      boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 0px',
                      ml: 5,
                    }}
                  >
                    <Typography sx={{ fontFamily: 'Sora', color: '#FF7345' }}>Goal {indicator.goal}</Typography>
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5 }}>
                      Code {indicator.code}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6 }}>
                      {indicator.code} {indicator.title}
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <Grid sx={{ height: '42vh', overflowY: 'scroll', mx: 3, backgroundColor: '#ffffff' }}>
              <Typography
                sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '20px', fontWeight: 500, my: 0.5, ml: 5 }}
              >
                Targets
              </Typography>
              <br />
              <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5, mx: 2, ml: 5 }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.
              </Typography>
              <br />
              <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5, mx: 2, ml: 5 }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua.
              </Typography>
            </Grid>
          </Box>
          <Dialog
            open={open}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title" sx={{ fontFamily: 'Sora', color: '#FF7345' }}>
              Goal {content.goal}
            </DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
              <DialogContentText
                id="scroll-dialog-description"
                ref={descriptionElementRef}
                tabIndex={-1}
                sx={{ display: 'flex', flexDirection: 'column' }}
              >
                <Typography sx={{ fontFamily: 'Sora', color: '#FF7345', fontSize: '14px', my: 0.5 }}>
                  Code {content.code}
                </Typography>
                <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6, my: 0.5 }}>
                  {content.code} {content.title}
                </Typography>
                <Typography
                  sx={{ fontFamily: 'Sora', color: '#FF7345', fontSize: '14px', marginBottom: 1, marginTop: 1 }}
                >
                  Indicators
                </Typography>
                {indData.map(data => (
                  <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6, my: 0.5 }}>
                    {data.code} {data.description}
                  </Typography>
                ))}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  fontFamily: 'Sora',
                  color: '#FF7345',
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog> */}
        </div>
      ) : clickedItem === 1 ? (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            width: '100%',
            height: ['200%', '300%', '150%'],
            marginTop: 10,
            px: 8,
          }}
        >
          <Indicators />
        </Box>
      ) : clickedItem === 2 ? (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            width: '100%',
            height: ['170%', '210%', '150%'],
            marginTop: 10,
            px: 8,
          }}
        >
          <UploadDocForm />
        </Box>
      ) : clickedItem === 3 ? (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            width: '100%',
            height: '200%',
            marginTop: 10,
            px: 8,
          }}
        >
          <VerifyContent />
        </Box>
      ) : clickedItem === 4 ? (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            width: '100%',
            height: '100%',
            marginTop: 10,
            px: 8,
          }}
        >
          <VerifyRequests />
        </Box>
      ) : clickedItem === 5 ? (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            width: '100%',
            height: '100%',
            marginTop: 10,
            px: 8,
          }}
        >
          <NewsEditorForm />
        </Box>
      ) : clickedItem == 6 ? (
        <Box
          sx={{
            backgroundColor: '#FAFAFC',
            width: '100%',
            height: '200%',
            marginTop: 10,
            px: 8,
          }}
        >
          <Published />
        </Box>
      ) : (
        'sjd'
      )}
    </Box>
  );
}

AdminDashboard.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default AdminDashboard;
